@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_193_834_607)
public val Res.string.kiosk_error_done: StringResource by lazy {
      StringResource("string:kiosk_error_done", "kiosk_error_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 165054, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 233694, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149953, 76),
      ))
    }

@delegate:ResourceContentHash(405_464_494)
public val Res.string.kiosk_error_locked: StringResource by lazy {
      StringResource("string:kiosk_error_locked", "kiosk_error_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 165143, 166),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 233811, 266),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150030, 110),
      ))
    }

@delegate:ResourceContentHash(-2_088_593_639)
public val Res.string.kiosk_error_no_checklist: StringResource by lazy {
      StringResource("string:kiosk_error_no_checklist", "kiosk_error_no_checklist", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 165310, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 234078, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150141, 88),
      ))
    }

@delegate:ResourceContentHash(-1_863_055_812)
public val Res.string.kiosk_error_no_pin: StringResource by lazy {
      StringResource("string:kiosk_error_no_pin", "kiosk_error_no_pin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 165403, 138),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 234219, 234),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150230, 122),
      ))
    }

@delegate:ResourceContentHash(1_629_032_031)
public val Res.string.kiosk_error_no_shift: StringResource by lazy {
      StringResource("string:kiosk_error_no_shift", "kiosk_error_no_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 165542, 200),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 234454, 296),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150353, 124),
      ))
    }

@delegate:ResourceContentHash(1_514_796_734)
public val Res.string.kiosk_error_not_clocked_in: StringResource by lazy {
      StringResource("string:kiosk_error_not_clocked_in", "kiosk_error_not_clocked_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 165743, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 234751, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150478, 78),
      ))
    }

@delegate:ResourceContentHash(-1_828_499_535)
public val Res.string.kiosk_error_not_manager: StringResource by lazy {
      StringResource("string:kiosk_error_not_manager", "kiosk_error_not_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 165838, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 234846, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150557, 83),
      ))
    }

@delegate:ResourceContentHash(-1_814_519_411)
public val Res.string.kiosk_error_not_on_break: StringResource by lazy {
      StringResource("string:kiosk_error_not_on_break", "kiosk_error_not_on_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 165934, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 234986, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150641, 68),
      ))
    }

@delegate:ResourceContentHash(125_938_145)
public val Res.string.kiosk_error_not_on_team: StringResource by lazy {
      StringResource("string:kiosk_error_not_on_team", "kiosk_error_not_on_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166011, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 235107, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150710, 83),
      ))
    }

@delegate:ResourceContentHash(-2_041_151_326)
public val Res.string.kiosk_error_not_your_shift: StringResource by lazy {
      StringResource("string:kiosk_error_not_your_shift", "kiosk_error_not_your_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166095, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 235227, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150794, 66),
      ))
    }

@delegate:ResourceContentHash(-2_062_846_915)
public val Res.string.kiosk_error_on_break: StringResource by lazy {
      StringResource("string:kiosk_error_on_break", "kiosk_error_on_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166166, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 235302, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150861, 68),
      ))
    }

@delegate:ResourceContentHash(68_858_884)
public val Res.string.kiosk_error_pin_disabled: StringResource by lazy {
      StringResource("string:kiosk_error_pin_disabled", "kiosk_error_pin_disabled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166219, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 235379, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150930, 128),
      ))
    }

@delegate:ResourceContentHash(-1_926_639_301)
public val Res.string.kiosk_error_pin_shape: StringResource by lazy {
      StringResource("string:kiosk_error_pin_shape", "kiosk_error_pin_shape", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166352, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 235592, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151059, 65),
      ))
    }

@delegate:ResourceContentHash(-1_980_248_420)
public val Res.string.kiosk_error_plan_ended: StringResource by lazy {
      StringResource("string:kiosk_error_plan_ended", "kiosk_error_plan_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166414, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 235686, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151125, 74),
      ))
    }

@delegate:ResourceContentHash(-530_498_548)
public val Res.string.kiosk_error_qr_disabled: StringResource by lazy {
      StringResource("string:kiosk_error_qr_disabled", "kiosk_error_qr_disabled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166481, 135),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 235797, 211),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151200, 143),
      ))
    }

@delegate:ResourceContentHash(-1_126_006_526)
public val Res.string.kiosk_error_qr_expired: StringResource by lazy {
      StringResource("string:kiosk_error_qr_expired", "kiosk_error_qr_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166617, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 236009, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151344, 102),
      ))
    }

@delegate:ResourceContentHash(-834_997_789)
public val Res.string.kiosk_error_qr_invalid: StringResource by lazy {
      StringResource("string:kiosk_error_qr_invalid", "kiosk_error_qr_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166704, 130),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 236176, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151447, 122),
      ))
    }

@delegate:ResourceContentHash(-258_077_160)
public val Res.string.kiosk_error_qr_used: StringResource by lazy {
      StringResource("string:kiosk_error_qr_used", "kiosk_error_qr_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166835, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 236363, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151570, 119),
      ))
    }

@delegate:ResourceContentHash(813_377_566)
public val Res.string.kiosk_error_revoked: StringResource by lazy {
      StringResource("string:kiosk_error_revoked", "kiosk_error_revoked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 166963, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 236535, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151690, 71),
      ))
    }

@delegate:ResourceContentHash(-1_639_075_136)
public val Res.string.kiosk_error_too_many_breaks: StringResource by lazy {
      StringResource("string:kiosk_error_too_many_breaks", "kiosk_error_too_many_breaks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167035, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 236643, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151762, 99),
      ))
    }

@delegate:ResourceContentHash(1_800_674_680)
public val Res.string.kiosk_error_wrong_pin: StringResource by lazy {
      StringResource("string:kiosk_error_wrong_pin", "kiosk_error_wrong_pin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167147, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 236795, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151862, 69),
      ))
    }

@delegate:ResourceContentHash(819_779_535)
public val Res.string.kiosk_exit: StringResource by lazy {
      StringResource("string:kiosk_exit", "kiosk_exit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167348, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 237080, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152059, 42),
      ))
    }

@delegate:ResourceContentHash(1_274_134_982)
public val Res.string.kiosk_exit_confirm: StringResource by lazy {
      StringResource("string:kiosk_exit_confirm", "kiosk_exit_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167229, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 236917, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151932, 34),
      ))
    }

@delegate:ResourceContentHash(-1_693_356_071)
public val Res.string.kiosk_exit_text: StringResource by lazy {
      StringResource("string:kiosk_exit_text", "kiosk_exit_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167264, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 236960, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151967, 91),
      ))
    }

@delegate:ResourceContentHash(1_212_432_449)
public val Res.string.kiosk_guided_access_hint: StringResource by lazy {
      StringResource("string:kiosk_guided_access_hint", "kiosk_guided_access_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167395, 244),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 237159, 336),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152102, 212),
      ))
    }

@delegate:ResourceContentHash(76_360_868)
public val Res.string.kiosk_no_matches: StringResource by lazy {
      StringResource("string:kiosk_no_matches", "kiosk_no_matches", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167640, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 237496, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152315, 40),
      ))
    }

@delegate:ResourceContentHash(-1_473_797_513)
public val Res.string.kiosk_no_one_today: StringResource by lazy {
      StringResource("string:kiosk_no_one_today", "kiosk_no_one_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167693, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 237569, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152356, 98),
      ))
    }

@delegate:ResourceContentHash(1_837_676_211)
public val Res.string.kiosk_offline_waiting: StringResource by lazy {
      StringResource("string:kiosk_offline_waiting", "kiosk_offline_waiting", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167788, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 237716, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152455, 81),
      ))
    }

@delegate:ResourceContentHash(346_815_036)
public val Res.string.kiosk_pair_button: StringResource by lazy {
      StringResource("string:kiosk_pair_button", "kiosk_pair_button", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167874, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 237846, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152537, 61),
      ))
    }

@delegate:ResourceContentHash(-829_710_501)
public val Res.string.kiosk_pair_code: StringResource by lazy {
      StringResource("string:kiosk_pair_code", "kiosk_pair_code", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 167964, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 237988, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152599, 39),
      ))
    }

@delegate:ResourceContentHash(-92_615_827)
public val Res.string.kiosk_pair_confirm: StringResource by lazy {
      StringResource("string:kiosk_pair_confirm", "kiosk_pair_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168008, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 238052, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152639, 34),
      ))
    }

@delegate:ResourceContentHash(1_567_649_002)
public val Res.string.kiosk_pair_name: StringResource by lazy {
      StringResource("string:kiosk_pair_name", "kiosk_pair_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168047, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 238107, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152674, 55),
      ))
    }

@delegate:ResourceContentHash(-39_963_762)
public val Res.string.kiosk_pair_text: StringResource by lazy {
      StringResource("string:kiosk_pair_text", "kiosk_pair_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168115, 195),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 238207, 359),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152730, 171),
      ))
    }

@delegate:ResourceContentHash(-1_576_174_340)
public val Res.string.kiosk_photo_explained: StringResource by lazy {
      StringResource("string:kiosk_photo_explained", "kiosk_photo_explained", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168311, 201),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 238567, 341),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152902, 181),
      ))
    }

@delegate:ResourceContentHash(-93_315_904)
public val Res.string.kiosk_photo_failed: StringResource by lazy {
      StringResource("string:kiosk_photo_failed", "kiosk_photo_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168513, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 238909, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153084, 66),
      ))
    }

@delegate:ResourceContentHash(824_264_295)
public val Res.string.kiosk_photo_skip: StringResource by lazy {
      StringResource("string:kiosk_photo_skip", "kiosk_photo_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168588, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239000, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153151, 32),
      ))
    }

@delegate:ResourceContentHash(-2_064_984_274)
public val Res.string.kiosk_photo_take: StringResource by lazy {
      StringResource("string:kiosk_photo_take", "kiosk_photo_take", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168621, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239053, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153184, 40),
      ))
    }

@delegate:ResourceContentHash(-43_568_054)
public val Res.string.kiosk_photo_title: StringResource by lazy {
      StringResource("string:kiosk_photo_title", "kiosk_photo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168666, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239110, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153225, 45),
      ))
    }

@delegate:ResourceContentHash(1_251_419_936)
public val Res.string.kiosk_pin_is_set: StringResource by lazy {
      StringResource("string:kiosk_pin_is_set", "kiosk_pin_is_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168736, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239188, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153271, 28),
      ))
    }

@delegate:ResourceContentHash(1_778_101_163)
public val Res.string.kiosk_pin_mismatch: StringResource by lazy {
      StringResource("string:kiosk_pin_mismatch", "kiosk_pin_mismatch", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168773, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239245, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153300, 46),
      ))
    }

@delegate:ResourceContentHash(1_680_537_986)
public val Res.string.kiosk_pin_new: StringResource by lazy {
      StringResource("string:kiosk_pin_new", "kiosk_pin_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168828, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239312, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153347, 33),
      ))
    }

@delegate:ResourceContentHash(397_725_055)
public val Res.string.kiosk_pin_not_set: StringResource by lazy {
      StringResource("string:kiosk_pin_not_set", "kiosk_pin_not_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168862, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239354, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153381, 37),
      ))
    }

@delegate:ResourceContentHash(1_998_586_183)
public val Res.string.kiosk_pin_remove: StringResource by lazy {
      StringResource("string:kiosk_pin_remove", "kiosk_pin_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168950, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239470, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153461, 40),
      ))
    }

@delegate:ResourceContentHash(-702_006_480)
public val Res.string.kiosk_pin_removed: StringResource by lazy {
      StringResource("string:kiosk_pin_removed", "kiosk_pin_removed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168904, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239416, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153419, 41),
      ))
    }

@delegate:ResourceContentHash(-1_740_319_808)
public val Res.string.kiosk_pin_repeat: StringResource by lazy {
      StringResource("string:kiosk_pin_repeat", "kiosk_pin_repeat", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 168987, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239523, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153502, 44),
      ))
    }

@delegate:ResourceContentHash(-1_551_915_453)
public val Res.string.kiosk_pin_save: StringResource by lazy {
      StringResource("string:kiosk_pin_save", "kiosk_pin_save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169068, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239628, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153583, 34),
      ))
    }

@delegate:ResourceContentHash(-1_234_123_489)
public val Res.string.kiosk_pin_saved: StringResource by lazy {
      StringResource("string:kiosk_pin_saved", "kiosk_pin_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169028, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239572, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153547, 35),
      ))
    }

@delegate:ResourceContentHash(-1_268_248_509)
public val Res.string.kiosk_pin_text: StringResource by lazy {
      StringResource("string:kiosk_pin_text", "kiosk_pin_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169107, 190),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 239679, 342),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153618, 154),
      ))
    }

@delegate:ResourceContentHash(350_627_721)
public val Res.string.kiosk_pin_title: StringResource by lazy {
      StringResource("string:kiosk_pin_title", "kiosk_pin_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169298, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 240022, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153773, 39),
      ))
    }

@delegate:ResourceContentHash(1_499_139_930)
public val Res.string.kiosk_qr_description: StringResource by lazy {
      StringResource("string:kiosk_qr_description", "kiosk_qr_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169342, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 240082, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153813, 88),
      ))
    }

@delegate:ResourceContentHash(-1_387_486_551)
public val Res.string.kiosk_qr_hint: StringResource by lazy {
      StringResource("string:kiosk_qr_hint", "kiosk_qr_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169459, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 240247, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153902, 57),
      ))
    }

@delegate:ResourceContentHash(728_073_824)
public val Res.string.kiosk_qr_offline: StringResource by lazy {
      StringResource("string:kiosk_qr_offline", "kiosk_qr_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169521, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 240329, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153960, 56),
      ))
    }

@delegate:ResourceContentHash(-350_266_487)
public val Res.string.kiosk_qr_only_hint: StringResource by lazy {
      StringResource("string:kiosk_qr_only_hint", "kiosk_qr_only_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169578, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 240406, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154017, 94),
      ))
    }

@delegate:ResourceContentHash(2_010_659_591)
public val Res.string.kiosk_qr_setting: StringResource by lazy {
      StringResource("string:kiosk_qr_setting", "kiosk_qr_setting", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169907, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 240959, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154338, 52),
      ))
    }

@delegate:ResourceContentHash(2_118_024_921)
public val Res.string.kiosk_qr_setting_help: StringResource by lazy {
      StringResource("string:kiosk_qr_setting_help", "kiosk_qr_setting_help", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169677, 229),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 240557, 401),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154112, 225),
      ))
    }

@delegate:ResourceContentHash(-1_134_975_265)
public val Res.string.kiosk_revoke: StringResource by lazy {
      StringResource("string:kiosk_revoke", "kiosk_revoke", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170200, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 241420, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154607, 28),
      ))
    }

@delegate:ResourceContentHash(901_154_291)
public val Res.string.kiosk_revoke_text: StringResource by lazy {
      StringResource("string:kiosk_revoke_text", "kiosk_revoke_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 169960, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 241024, 257),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154391, 125),
      ))
    }

@delegate:ResourceContentHash(372_252_375)
public val Res.string.kiosk_revoke_title: StringResource by lazy {
      StringResource("string:kiosk_revoke_title", "kiosk_revoke_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170098, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 241282, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154517, 42),
      ))
    }

@delegate:ResourceContentHash(788_899_098)
public val Res.string.kiosk_revoked_done: StringResource by lazy {
      StringResource("string:kiosk_revoked_done", "kiosk_revoked_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170149, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 241345, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154560, 46),
      ))
    }

@delegate:ResourceContentHash(1_789_187_592)
public val Res.string.kiosk_search_hint: StringResource by lazy {
      StringResource("string:kiosk_search_hint", "kiosk_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170233, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 241469, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154636, 45),
      ))
    }

@delegate:ResourceContentHash(2_127_465_068)
public val Res.string.kiosk_settings_help: StringResource by lazy {
      StringResource("string:kiosk_settings_help", "kiosk_settings_help", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170283, 227),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 241535, 379),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154682, 207),
      ))
    }

@delegate:ResourceContentHash(1_853_755_377)
public val Res.string.kiosk_settings_name_hint: StringResource by lazy {
      StringResource("string:kiosk_settings_name_hint", "kiosk_settings_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170511, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 241915, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154890, 60),
      ))
    }

@delegate:ResourceContentHash(827_615_140)
public val Res.string.kiosk_settings_none: StringResource by lazy {
      StringResource("string:kiosk_settings_none", "kiosk_settings_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170604, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242040, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154951, 59),
      ))
    }

@delegate:ResourceContentHash(-1_250_667_703)
public val Res.string.kiosk_settings_pair: StringResource by lazy {
      StringResource("string:kiosk_settings_pair", "kiosk_settings_pair", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170672, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242148, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155011, 47),
      ))
    }

@delegate:ResourceContentHash(-467_064_519)
public val Res.string.kiosk_settings_title: StringResource by lazy {
      StringResource("string:kiosk_settings_title", "kiosk_settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170720, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242224, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155059, 48),
      ))
    }

@delegate:ResourceContentHash(2_047_194_839)
public val Res.string.kiosk_someone_else: StringResource by lazy {
      StringResource("string:kiosk_someone_else", "kiosk_someone_else", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170793, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242333, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155108, 42),
      ))
    }

@delegate:ResourceContentHash(1_568_502_611)
public val Res.string.kiosk_state_done: StringResource by lazy {
      StringResource("string:kiosk_state_done", "kiosk_state_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170836, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242388, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155151, 44),
      ))
    }

@delegate:ResourceContentHash(-1_636_284_696)
public val Res.string.kiosk_state_later: StringResource by lazy {
      StringResource("string:kiosk_state_later", "kiosk_state_later", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170885, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242453, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155196, 37),
      ))
    }

@delegate:ResourceContentHash(-550_211_408)
public val Res.string.kiosk_state_on_break: StringResource by lazy {
      StringResource("string:kiosk_state_on_break", "kiosk_state_on_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170923, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242491, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155234, 56),
      ))
    }

@delegate:ResourceContentHash(-15_984_703)
public val Res.string.kiosk_state_ready: StringResource by lazy {
      StringResource("string:kiosk_state_ready", "kiosk_state_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 170980, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242556, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155291, 49),
      ))
    }

@delegate:ResourceContentHash(-1_087_012_780)
public val Res.string.kiosk_state_working: StringResource by lazy {
      StringResource("string:kiosk_state_working", "kiosk_state_working", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171030, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242614, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155341, 51),
      ))
    }

@delegate:ResourceContentHash(-320_384_802)
public val Res.string.kiosk_sync_refused: StringResource by lazy {
      StringResource("string:kiosk_sync_refused", "kiosk_sync_refused", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171078, 174),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242678, 286),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155393, 150),
      ))
    }

@delegate:ResourceContentHash(-1_858_807_330)
public val Res.string.kiosk_synced_late: StringResource by lazy {
      StringResource("string:kiosk_synced_late", "kiosk_synced_late", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171253, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 242965, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155544, 57),
      ))
    }

@delegate:ResourceContentHash(2_067_394_091)
public val Res.string.kiosk_tip_share: StringResource by lazy {
      StringResource("string:kiosk_tip_share", "kiosk_tip_share", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171327, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243075, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155602, 51),
      ))
    }

@delegate:ResourceContentHash(-1_274_481_675)
public val Res.string.kiosk_tips: StringResource by lazy {
      StringResource("string:kiosk_tips", "kiosk_tips", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171922, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243890, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156137, 26),
      ))
    }

@delegate:ResourceContentHash(-416_540_629)
public val Res.string.kiosk_tips_amount_title: StringResource by lazy {
      StringResource("string:kiosk_tips_amount_title", "kiosk_tips_amount_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171391, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243159, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155654, 47),
      ))
    }

@delegate:ResourceContentHash(95_457_784)
public val Res.string.kiosk_tips_change: StringResource by lazy {
      StringResource("string:kiosk_tips_change", "kiosk_tips_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171451, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243223, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155702, 49),
      ))
    }

@delegate:ResourceContentHash(1_690_575_165)
public val Res.string.kiosk_tips_continue: StringResource by lazy {
      StringResource("string:kiosk_tips_continue", "kiosk_tips_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171497, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243281, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155752, 39),
      ))
    }

@delegate:ResourceContentHash(-177_291_452)
public val Res.string.kiosk_tips_none_yet: StringResource by lazy {
      StringResource("string:kiosk_tips_none_yet", "kiosk_tips_none_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171533, 155),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243321, 251),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155792, 123),
      ))
    }

@delegate:ResourceContentHash(-349_335_397)
public val Res.string.kiosk_tips_split: StringResource by lazy {
      StringResource("string:kiosk_tips_split", "kiosk_tips_split", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171689, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243573, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155916, 44),
      ))
    }

@delegate:ResourceContentHash(1_174_636_319)
public val Res.string.kiosk_tips_text: StringResource by lazy {
      StringResource("string:kiosk_tips_text", "kiosk_tips_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171734, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243642, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155961, 75),
      ))
    }

@delegate:ResourceContentHash(1_703_924_250)
public val Res.string.kiosk_tips_total: StringResource by lazy {
      StringResource("string:kiosk_tips_total", "kiosk_tips_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171810, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243746, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156037, 48),
      ))
    }

@delegate:ResourceContentHash(168_145_575)
public val Res.string.kiosk_tips_who: StringResource by lazy {
      StringResource("string:kiosk_tips_who", "kiosk_tips_who", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171867, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243819, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156086, 50),
      ))
    }

@delegate:ResourceContentHash(240_153_953)
public val Res.string.kiosk_unplanned_cover: StringResource by lazy {
      StringResource("string:kiosk_unplanned_cover", "kiosk_unplanned_cover", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 171953, 129),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 243925, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156164, 113),
      ))
    }

@delegate:ResourceContentHash(1_442_520_632)
public val Res.string.kiosk_unplanned_extra: StringResource by lazy {
      StringResource("string:kiosk_unplanned_extra", "kiosk_unplanned_extra", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172083, 157),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244099, 249),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156278, 145),
      ))
    }

@delegate:ResourceContentHash(-535_685_515)
public val Res.string.kiosk_via_qr: StringResource by lazy {
      StringResource("string:kiosk_via_qr", "kiosk_via_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172241, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244349, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156424, 36),
      ))
    }

@delegate:ResourceContentHash(-187_014_688)
public val Res.string.kiosk_via_tablet: StringResource by lazy {
      StringResource("string:kiosk_via_tablet", "kiosk_via_tablet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172278, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244398, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156461, 40),
      ))
    }

@delegate:ResourceContentHash(1_722_722_536)
public val Res.string.kiosk_who_title: StringResource by lazy {
      StringResource("string:kiosk_who_title", "kiosk_who_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172319, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244459, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156502, 47),
      ))
    }

@delegate:ResourceContentHash(-51_957_788)
public val Res.string.labor_percentage: StringResource by lazy {
      StringResource("string:labor_percentage", "labor_percentage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172459, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244679, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156606, 48),
      ))
    }

@delegate:ResourceContentHash(-959_385_960)
public val Res.string.labor_percentage_income: StringResource by lazy {
      StringResource("string:labor_percentage_income", "labor_percentage_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172387, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244563, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156550, 55),
      ))
    }

@delegate:ResourceContentHash(-1_401_999_140)
public val Res.string.labour_budget: StringResource by lazy {
      StringResource("string:labour_budget", "labour_budget", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173520, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 246064, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157583, 41),
      ))
    }

@delegate:ResourceContentHash(273_788_342)
public val Res.string.labour_budget_actual: StringResource by lazy {
      StringResource("string:labour_budget_actual", "labour_budget_actual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172524, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244792, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156655, 36),
      ))
    }

@delegate:ResourceContentHash(1_478_095_007)
public val Res.string.labour_budget_amount: StringResource by lazy {
      StringResource("string:labour_budget_amount", "labour_budget_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172565, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244833, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156692, 36),
      ))
    }

@delegate:ResourceContentHash(127_298_012)
public val Res.string.labour_budget_effect_left: StringResource by lazy {
      StringResource("string:labour_budget_effect_left", "labour_budget_effect_left", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172606, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244878, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156729, 53),
      ))
    }

@delegate:ResourceContentHash(460_188_625)
public val Res.string.labour_budget_effect_over: StringResource by lazy {
      StringResource("string:labour_budget_effect_over", "labour_budget_effect_over", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172664, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 244956, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156783, 65),
      ))
    }

@delegate:ResourceContentHash(-799_443_235)
public val Res.string.labour_budget_effect_warning: StringResource by lazy {
      StringResource("string:labour_budget_effect_warning", "labour_budget_effect_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172730, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 245038, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156849, 96),
      ))
    }

@delegate:ResourceContentHash(-1_992_996_652)
public val Res.string.labour_budget_effect_week_left: StringResource by lazy {
      StringResource("string:labour_budget_effect_week_left", "labour_budget_effect_week_left", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172835, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 245199, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156946, 58),
      ))
    }

@delegate:ResourceContentHash(595_226_453)
public val Res.string.labour_budget_effect_week_over: StringResource by lazy {
      StringResource("string:labour_budget_effect_week_over", "labour_budget_effect_week_over", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172906, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 245298, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157005, 70),
      ))
    }

@delegate:ResourceContentHash(-764_913_382)
public val Res.string.labour_budget_left: StringResource by lazy {
      StringResource("string:labour_budget_left", "labour_budget_left", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 172985, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 245397, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157076, 38),
      ))
    }

@delegate:ResourceContentHash(1_774_908_464)
public val Res.string.labour_budget_open_estimated: StringResource by lazy {
      StringResource("string:labour_budget_open_estimated", "labour_budget_open_estimated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 173028, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 245460, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157115, 104),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString20Resources(map: MutableMap<String, StringResource>) {
  map.put("kiosk_error_done", Res.string.kiosk_error_done)
  map.put("kiosk_error_locked", Res.string.kiosk_error_locked)
  map.put("kiosk_error_no_checklist", Res.string.kiosk_error_no_checklist)
  map.put("kiosk_error_no_pin", Res.string.kiosk_error_no_pin)
  map.put("kiosk_error_no_shift", Res.string.kiosk_error_no_shift)
  map.put("kiosk_error_not_clocked_in", Res.string.kiosk_error_not_clocked_in)
  map.put("kiosk_error_not_manager", Res.string.kiosk_error_not_manager)
  map.put("kiosk_error_not_on_break", Res.string.kiosk_error_not_on_break)
  map.put("kiosk_error_not_on_team", Res.string.kiosk_error_not_on_team)
  map.put("kiosk_error_not_your_shift", Res.string.kiosk_error_not_your_shift)
  map.put("kiosk_error_on_break", Res.string.kiosk_error_on_break)
  map.put("kiosk_error_pin_disabled", Res.string.kiosk_error_pin_disabled)
  map.put("kiosk_error_pin_shape", Res.string.kiosk_error_pin_shape)
  map.put("kiosk_error_plan_ended", Res.string.kiosk_error_plan_ended)
  map.put("kiosk_error_qr_disabled", Res.string.kiosk_error_qr_disabled)
  map.put("kiosk_error_qr_expired", Res.string.kiosk_error_qr_expired)
  map.put("kiosk_error_qr_invalid", Res.string.kiosk_error_qr_invalid)
  map.put("kiosk_error_qr_used", Res.string.kiosk_error_qr_used)
  map.put("kiosk_error_revoked", Res.string.kiosk_error_revoked)
  map.put("kiosk_error_too_many_breaks", Res.string.kiosk_error_too_many_breaks)
  map.put("kiosk_error_wrong_pin", Res.string.kiosk_error_wrong_pin)
  map.put("kiosk_exit", Res.string.kiosk_exit)
  map.put("kiosk_exit_confirm", Res.string.kiosk_exit_confirm)
  map.put("kiosk_exit_text", Res.string.kiosk_exit_text)
  map.put("kiosk_guided_access_hint", Res.string.kiosk_guided_access_hint)
  map.put("kiosk_no_matches", Res.string.kiosk_no_matches)
  map.put("kiosk_no_one_today", Res.string.kiosk_no_one_today)
  map.put("kiosk_offline_waiting", Res.string.kiosk_offline_waiting)
  map.put("kiosk_pair_button", Res.string.kiosk_pair_button)
  map.put("kiosk_pair_code", Res.string.kiosk_pair_code)
  map.put("kiosk_pair_confirm", Res.string.kiosk_pair_confirm)
  map.put("kiosk_pair_name", Res.string.kiosk_pair_name)
  map.put("kiosk_pair_text", Res.string.kiosk_pair_text)
  map.put("kiosk_photo_explained", Res.string.kiosk_photo_explained)
  map.put("kiosk_photo_failed", Res.string.kiosk_photo_failed)
  map.put("kiosk_photo_skip", Res.string.kiosk_photo_skip)
  map.put("kiosk_photo_take", Res.string.kiosk_photo_take)
  map.put("kiosk_photo_title", Res.string.kiosk_photo_title)
  map.put("kiosk_pin_is_set", Res.string.kiosk_pin_is_set)
  map.put("kiosk_pin_mismatch", Res.string.kiosk_pin_mismatch)
  map.put("kiosk_pin_new", Res.string.kiosk_pin_new)
  map.put("kiosk_pin_not_set", Res.string.kiosk_pin_not_set)
  map.put("kiosk_pin_remove", Res.string.kiosk_pin_remove)
  map.put("kiosk_pin_removed", Res.string.kiosk_pin_removed)
  map.put("kiosk_pin_repeat", Res.string.kiosk_pin_repeat)
  map.put("kiosk_pin_save", Res.string.kiosk_pin_save)
  map.put("kiosk_pin_saved", Res.string.kiosk_pin_saved)
  map.put("kiosk_pin_text", Res.string.kiosk_pin_text)
  map.put("kiosk_pin_title", Res.string.kiosk_pin_title)
  map.put("kiosk_qr_description", Res.string.kiosk_qr_description)
  map.put("kiosk_qr_hint", Res.string.kiosk_qr_hint)
  map.put("kiosk_qr_offline", Res.string.kiosk_qr_offline)
  map.put("kiosk_qr_only_hint", Res.string.kiosk_qr_only_hint)
  map.put("kiosk_qr_setting", Res.string.kiosk_qr_setting)
  map.put("kiosk_qr_setting_help", Res.string.kiosk_qr_setting_help)
  map.put("kiosk_revoke", Res.string.kiosk_revoke)
  map.put("kiosk_revoke_text", Res.string.kiosk_revoke_text)
  map.put("kiosk_revoke_title", Res.string.kiosk_revoke_title)
  map.put("kiosk_revoked_done", Res.string.kiosk_revoked_done)
  map.put("kiosk_search_hint", Res.string.kiosk_search_hint)
  map.put("kiosk_settings_help", Res.string.kiosk_settings_help)
  map.put("kiosk_settings_name_hint", Res.string.kiosk_settings_name_hint)
  map.put("kiosk_settings_none", Res.string.kiosk_settings_none)
  map.put("kiosk_settings_pair", Res.string.kiosk_settings_pair)
  map.put("kiosk_settings_title", Res.string.kiosk_settings_title)
  map.put("kiosk_someone_else", Res.string.kiosk_someone_else)
  map.put("kiosk_state_done", Res.string.kiosk_state_done)
  map.put("kiosk_state_later", Res.string.kiosk_state_later)
  map.put("kiosk_state_on_break", Res.string.kiosk_state_on_break)
  map.put("kiosk_state_ready", Res.string.kiosk_state_ready)
  map.put("kiosk_state_working", Res.string.kiosk_state_working)
  map.put("kiosk_sync_refused", Res.string.kiosk_sync_refused)
  map.put("kiosk_synced_late", Res.string.kiosk_synced_late)
  map.put("kiosk_tip_share", Res.string.kiosk_tip_share)
  map.put("kiosk_tips", Res.string.kiosk_tips)
  map.put("kiosk_tips_amount_title", Res.string.kiosk_tips_amount_title)
  map.put("kiosk_tips_change", Res.string.kiosk_tips_change)
  map.put("kiosk_tips_continue", Res.string.kiosk_tips_continue)
  map.put("kiosk_tips_none_yet", Res.string.kiosk_tips_none_yet)
  map.put("kiosk_tips_split", Res.string.kiosk_tips_split)
  map.put("kiosk_tips_text", Res.string.kiosk_tips_text)
  map.put("kiosk_tips_total", Res.string.kiosk_tips_total)
  map.put("kiosk_tips_who", Res.string.kiosk_tips_who)
  map.put("kiosk_unplanned_cover", Res.string.kiosk_unplanned_cover)
  map.put("kiosk_unplanned_extra", Res.string.kiosk_unplanned_extra)
  map.put("kiosk_via_qr", Res.string.kiosk_via_qr)
  map.put("kiosk_via_tablet", Res.string.kiosk_via_tablet)
  map.put("kiosk_who_title", Res.string.kiosk_who_title)
  map.put("labor_percentage", Res.string.labor_percentage)
  map.put("labor_percentage_income", Res.string.labor_percentage_income)
  map.put("labour_budget", Res.string.labour_budget)
  map.put("labour_budget_actual", Res.string.labour_budget_actual)
  map.put("labour_budget_amount", Res.string.labour_budget_amount)
  map.put("labour_budget_effect_left", Res.string.labour_budget_effect_left)
  map.put("labour_budget_effect_over", Res.string.labour_budget_effect_over)
  map.put("labour_budget_effect_warning", Res.string.labour_budget_effect_warning)
  map.put("labour_budget_effect_week_left", Res.string.labour_budget_effect_week_left)
  map.put("labour_budget_effect_week_over", Res.string.labour_budget_effect_week_over)
  map.put("labour_budget_left", Res.string.labour_budget_left)
  map.put("labour_budget_open_estimated", Res.string.labour_budget_open_estimated)
}
